import classNames from "classnames/bind";
import styles from "./ManageChanel.module.css";
import InProcessBuild from "../../../components/InProcessBuild";
import Filter from "./Filter";
import { Button, Col, Row, Switch, Table } from "antd";
import { columns } from "./configManageChanel";
import Pagination from "../../../components/Pagination/Pagination";
import { useEffect, useState } from "react";
import { DeleteIcon, EditIcon } from "../../../components/Icons/Icons";
import { Alert, Toast } from "../../../components";
import { manageNotification } from "../../../services/api/manageNotification";
import Modal from "./ModalConnectTelegram/Modal";

const cx = classNames.bind(styles);

function ManageChanel() {
    const [colTable, setColTable] = useState([]);
    const [listChanel, setListChanel] = useState([]);
    const [resfresh, setRefresh] = useState([]);
    const [formFilter, setFormFilter] = useState({
        name: '',
        method: null,
        page: 1,
        size: 10,
        totalPage: 1
    });
    const [showEditChanel, setShowEditChanel] = useState({
        show: false,
        id: null
    })
    const [showDelete, setShowDelete] = useState({
        show: false,
        id: null
    })
    const handleRefresh = () => {
        setRefresh(!resfresh)
    }

    const handleShowEdit = (item) => {
        setShowEditChanel({
            show: !!item?.code,
            id: item?.code
        })
    }
    const handleShowDelete = (item) => {
        setShowEditChanel({
            show: !!item?.code,
            id: item?.code
        })
    }
    const handleChangeStatus = async (item) => {
        try {
            const data = {
                status_noti: item?.status ? "0" : "1"
            }
            await manageNotification?.putChangeStatusNotification(item?.code, data);
            Toast.open(`${item?.status ? "Tắt" : "Bật"} kênh thông báo thành công`, "success")
        } catch (error) {
            Toast.open(`${item?.status ? "Tắt" : "Bật"} kênh thông báo không thành công`, "danger")
        }
    }
    useEffect(() => {
        const lisCol = columns?.map((item) => {
            if (item.key === 'action') {
                return {
                    ...item,
                    render: (val, row, inde) => {
                        return (
                            <Row gutter={[0, 8]} justify={'center'} align={'middle'}>
                                <Col span={8}>
                                    <Button className={cx('btn-control')} onClick={() => handleShowDelete(row)}><DeleteIcon /></Button>
                                </Col>
                                <Col span={8}>
                                    <Button className={cx('btn-control')} onClick={() => handleShowEdit(row)}>
                                        <EditIcon />
                                    </Button>
                                </Col>
                            </Row>
                        )
                    }
                }
            }
            if (item?.key === "status") {
                return {
                    ...item,
                    render: (col, row, index) => (
                        <Switch
                            className={cx("switch")}
                            size="default"
                            defaultValue={!!col}
                            onChange={() => handleChangeStatus(row)}
                        />
                    )
                }
            }
            return item;
        })
        setColTable(lisCol);
    }, [columns])

    const getListNotificationChanel = async () => {
        try {
            const param = {
                method: formFilter?.method,
                username: formFilter?.name?.trim()?.length > 0 ? formFilter?.name : null,
                page: formFilter?.page,
                size: formFilter?.size
            }
            const res = await manageNotification.getListNotificationChanel(param);
            if (res?.data) {
                const listChanel = res?.data?.map((item, index) => {
                    return {
                        stt: index + 1,
                        name_account: item?.USERNAME || "",
                        name_show: item?.SUBJECT_NAME || "",
                        company: item?.COMPANY_NAME || "",
                        detail: item?.DETAIL || "",
                        notifi_chanel: item?.CHANNEL || "",
                        status: item?.METHOD,
                        code: item?.CODE || ""
                    }
                });
                setListChanel(listChanel);
                setFormFilter(pre => ({ ...pre, totalPage: Math.ceil(res?.count / 10) }))
            }
        } catch (error) {
            // console.log(error);
            Toast.open("Lấy danh sách kênh thông báo không thành công", "danger")
        }
    }
    useEffect(() => {
        getListNotificationChanel()
    }, [resfresh, formFilter?.name, formFilter?.method, formFilter?.page])

    const handleChangeFilter = (key, val) => {
        setFormFilter((pre) => ({ ...pre, [key]: val, page: 1 }))
    }

    const handleNext = () => {
        setFormFilter((pre) => ({ ...pre, page: pre.page + 1 }))
    }
    const handlePrev = () => {
        setFormFilter((pre) => ({ ...pre, page: pre.page - 1 }))
    }
    const handleChose = (page) => {
        setFormFilter((pre) => ({ ...pre, page: page }))
    }
    const handleDelete = async () => {
        try {
            await manageNotification.deleteRemoveNotificationChannel(showDelete.id);
            handleShowDelete();
            handleRefresh();
            Toast.open("Xóa kênh thông báo không công", "danger");
        } catch (error) {
            Toast.open("Xóa kênh thông báo không thành công", "danger");
        }
    }

    return (
        <>
            <div className={cx("header")}>
                <h1 className={cx("title")}>Quản lý kênh thông báo</h1>
            </div>
            {/* filter */}
            <Filter
                handleRefresh={handleRefresh}
                form={formFilter}
                onChange={handleChangeFilter}
            />
            {/* content */}
            <div className={cx("content")}>
                <Table columns={colTable} className={cx('table')} dataSource={listChanel} pagination={false} />
                <div className={cx('pagination')}>
                    <Pagination
                        currentPage={formFilter?.page}
                        pages={formFilter?.totalPage}
                        onNext={handleNext}
                        onPrevious={handlePrev}
                        onClick={handleChose}
                    />
                </div>
                {/* loading */}
            </div>
            {/* modal edit */}
            {showEditChanel?.show && <Modal
                handleRefresh={handleRefresh}
                id={showEditChanel.id}
                onClose={() => handleShowEdit()}
            />}
            {/* confirm delete */}
            {showDelete?.show && <Alert title={"Bạn có muốn xóa kênh này không"} onOk={handleDelete} onClose={() => handleShowDelete()} />}
        </>
    )
}

export default ManageChanel;